<template>
<div class='b-blue-background b-blue-background__opacity b-blue-background--fixed'>
    <FwPopup
        :centered='true'
        :isFixed='true'
        iconColor='#BEC7D4'
        max-width='400px'
        width='auto'
        title=''
        :allowBackgroundScrolling='true'
        :showClosePopup='true'
        popupBackground='#F8F9FA'
        popupRadius='20px'
        heightValue='100%'
        @close='$emit("close")'>
        <template #body>
            <div class='h-flex-dir-column  h-flex-center'>
                <h2 class='h-font-22 h-mt-0 h-mb-0 h-text-center'>
                    {{ headerText }}
                </h2>
                <p v-if='bodyText'
                   class='h-mv-20 h-text-center'>
                    {{ bodyText }}
                </p>
                <p v-if='subMessage'
                   class='h-mt-10 h-mb-20 h-text-center h-fw-500'>
                    {{ $t('WORKER.POPUP.INVITATION.CHECK') }}
                </p>
                <ul v-if='listToApprove' class='h-mv-0 h-pl-0'>
                    <li v-if='!workingHours' class='h-fw-500 h-mv-10'>
                        - {{ $t('WORKER.POPUP.INVITATION.CHECK.ITEM.HOURS.TITLE') }}
                        <span class='h-font-14'>
                            {{ $t('WORKER.POPUP.INVITATION.CHECK.ITEM.HOURS.TEXT') }}
                        </span>
                    </li>
                    <li v-if='!addressConfirm' class='h-fw-500 h-mv-10'>
                        - {{ $t('WORKER.POPUP.INVITATION.CHECK.ITEM.ADDRESS.TITLE') }}
                        <router-link :to='`/consult/companies/edit/${companyId}`'>
                            <span style='text-decoration: underline' class='h-font-14'>
                                {{ $t('WORKER.POPUP.INVITATION.CHECK.ITEM.ADDRESS.TEXT') }}
                            </span>
                        </router-link>
                    </li>
                </ul>
            </div>
        </template>
        <template #footer>
            <div class='h-flex h-flex-center'>
                <FwButton
                    :id='buttonId'
                    class='h-mt-20'
                    borderRadiusType='small-border'
                    @click='onSignIn'>
                    {{ buttonText }}
                </FwButton>
            </div>
        </template>
    </FwPopup>
</div>
</template>

<script lang='ts'>
import { Component, Prop, Vue } from 'vue-facing-decorator';

@Component({
    emits: [`onSignIn`, `closeSuccess`, `close`],
})
export default class InformationCalendarSyncPopup extends Vue {
    @Prop({ type: String, default: null }) readonly headerText!: string;
    @Prop({ type: String, default: null }) readonly buttonId!: string;
    @Prop({ type: String, default: null }) readonly subMessage!: string;
    @Prop({ type: String, default: null }) readonly bodyText!: string;
    @Prop({ type: String, default: null }) readonly buttonText!: string;
    @Prop({ type: String, default: null }) readonly companyId!: string;
    @Prop({ type: Boolean, default: false }) readonly listToApprove!: boolean;
    @Prop({ type: Boolean, default: false }) readonly workingHours!: boolean;
    @Prop({ type: Boolean, default: false }) readonly addressConfirm!: boolean;

    async onSignIn() {
        try {
            await this.$emit('onSignIn');
            this.$emit('closeSuccess');
        } catch (e) {
            console.log(e);
        }
    }
}
</script>
